import { makeObservable, override } from 'mobx';

import { IApiClient } from '../../../app/data/client';
import Logger from '../../../app/shared/Logger';
import { PricelistFormTranslation } from '../../localization/ModuleTranslation';
import type { CustomerPricelistData } from '../../model';
import { UpdateCustomerPricelistCommand } from '../../queries';
import PricelistFormState, { PricelistFormResult } from './PricelistFormState';

export default class EditPricelistFormState extends PricelistFormState {
  private pricelistId: string;

  constructor(client: IApiClient, translation: PricelistFormTranslation) {
    super(client, translation);
    makeObservable(this);
  }

  @override
  public reset(pricelist?: CustomerPricelistData): void {
    super.reset(pricelist);
    this.pricelistId = pricelist?.id;
  }

  public async submit(): Promise<PricelistFormResult> {
    this.validate();

    if (!this.isValid) {
      return { isSuccess: false };
    }

    try {
      const response = await this.client.send(
        new UpdateCustomerPricelistCommand({
          pricelistId: this.pricelistId,
          name: this.name.value,
          description: this.description.value,
        }),
      );

      return { isSuccess: true, pricelist: response.pricelist };
    } catch (error) {
      Logger.exception('Updating a price list failed', error);

      return this.toFailure(error, this.translation.errors.updateFailed);
    }
  }
}
